/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../../component/Inc/Paging';
import Tab from '../../../component/Inc/Tab';
import Upload from '../../../component/Inc/Upload';
const sampleImg = 'https://via.placeholder.com/122x172';
function ParkingFee() {
  const [modalOpen, setModalOpen] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '승인 요청', value: 1},
    {title: '1차 승인', value: 2},
    {title: '승인 완료', value: 3},
    {title: '승인 불가', value: 4}
  ];
  return (
    <main className="com_container com_parking">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_9">주차비 정산</h2>
          <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">
            주차비 청구
          </button>
        </section>
        <div className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top type_column">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <p className="notice">
                승인된 주차비는 회사 급여통장으로 이체됩니다. 다른 방식을 원하시면, 인사총무부로 문의하여 주세요. <br />
                &lt;필독&gt; 공영주차장 정산일자 지정제 도입 &lt;공지&gt; 21년 2월 부터 1개월 지난 영수증은 주차비 소급 적용하지않을 예정 이오니 착오 없으시길 바랍니다.
              </p>
              <hr className="com_divider" />
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col />
                <col width="15%" />
                <col width="15%" />
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01"></label>
                  </th>
                  <th>요청일</th>
                  <th>요청자</th>
                  <th>1차 승인자</th>
                  <th>비고</th>
                  <th>입차시간</th>
                  <th>출차시간</th>
                  <th>청구액</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="checkbox" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </td>
                  <td>2022.08.25</td>
                  <td>
                    <button className="name btn_link">김요청103</button>
                  </td>
                  <td>김관리103</td>
                  <td>교재수령</td>
                  <td>2022.08.25 12:30</td>
                  <td>2022.08.25 20:30</td>
                  <td>800,000</td>
                  <td className="td_red">
                    승인불가 <br />
                    2022,09,25
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>
                        <input type="checkbox" id={`chk${idx}`} className="com_chk" />
                        <label htmlFor={`chk${idx}`}></label>
                      </td>
                      <td>2022.08.25</td>
                      <td>
                        <button className="name btn_link">김요청103</button>
                      </td>
                      <td>김관리103</td>
                      <td>내사수업</td>
                      <td>2022.08.25 12:30</td>
                      <td>2022.08.25 20:30</td>
                      <td>800,000</td>
                      <td className="td_point">
                        승인완료 <br />
                        2022,09,25
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info_group">
              <div className="com_info">
                <span className="lab">요청자</span>
                <p className="name">홍길동104</p>
                <span className="dot" />
                <p className="date">2023.05.20 11:30</p>
              </div>
              <div className="com_info">
                <p className="txt">1차승인자 : 영어 배정담당</p>
              </div>
              <button className="btn_edit" />
            </div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="28%" />
                <col width="60%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>청구자</th>
                  <td>김교사302</td>
                </tr>
                <tr>
                  <th>방문구분</th>
                  <td>
                    <select className="select">
                      <option value="교재수령">교재수령</option>
                      <option value="방문">방문</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>관련수업</th>
                  <td>
                    <select className="select">
                      <option value="">수업 선택</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>주차장 명</th>
                  <td>
                    <input type="text" className="input" defaultValue={`강남주차장`} />
                  </td>
                </tr>
                <tr>
                  <th>방문사유</th>
                  <td>
                    <input type="text" className="input" defaultValue={`하승유 스터디카페 수업`} />
                  </td>
                </tr>
                <tr>
                  <th>입차시간</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <select className="select">
                        <option value="18시">18시</option>
                        <option value="17시">17시</option>
                      </select>
                      <select className="select">
                        <option value="30분">30분</option>
                        <option value="00분">00분</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>출차시간</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <select className="select">
                        <option value="18시">18시</option>
                        <option value="17시">17시</option>
                      </select>
                      <select className="select">
                        <option value="30분">30분</option>
                        <option value="00분">00분</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>청구금액</th>
                  <td>
                    <input type="text" className="input" defaultValue={`78,000`} />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_input_upload">
              <Upload title="파일 등록" className="com_btn gray xs wl" />
              <p className="file">
                <span className="txt">File name.pdf</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
                <button type="button" className="btn_down" onClick={() => {}}></button>
              </p>
            </div>
            <div className="img_box">
              <img src={sampleImg} alt="영수증 이미지" />
            </div>
            <div className="com_info_list">
              <div className="item">
                <span className="txt">1차 승인자 : 김승인132 ㅣ 2023, 05, 12</span>
              </div>
              <div className="item">
                <span className="txt">2차 승인자 : 인사팀 : 김인사132 ㅣ 2023, 05, 12</span>
                <span className="txt_red">승인불가</span>
              </div>
            </div>
            <div className="input_row">
              <select className="select">
                <option value="일부 승인">일부 승인</option>
              </select>
              <input type="text" className="input" defaultValue={`승인 금액 입력`} />
            </div>
            <div className="check">
              <input type="checkbox" name="chk" id="chkComp" className="com_chk" />
              <label htmlFor="chkComp">결제 완료</label>
            </div>
            <div className="com_btn_wrap center bottom">
              <div className="com_btn orange s wl">승인</div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}

export default ParkingFee;
